import { LabReqTestOption } from '@care-portals/api-interfaces';

export const qcProfileFields: { [key: string]: Array<LabReqTestOption> } = {
  fields1: [
    {
      type: 'boolean',
      id: 'TIBCP',
      label: 'ANEMIA PROFILE (TIBCP)',
      description: 'Iron, TIBC, % saturation'
    },
    {
      type: 'boolean',
      id: 'ANEM1',
      label: 'ANEMIA PROFILE #1 (ANEM1)',
      description:
        'Hemogram & sedimentation, Iron, TIBC, UIBC, % saturation, vitamin B12, folic acid'
    },
    {
      type: 'boolean',
      id: 'SMAC',
      label: 'BIO-C PROFILE (SMAC)',
      description:
        'Glucose AC, urea, total bilirubin, calcium, creatinine, cholesterol, uric acid, alkaline, phosphatase, AST, LDH, total protein, albumin, phosphorus, ALT, GGT, triglycerides'
    },
    {
      type: 'boolean',
      id: 'SMACLYT',
      label: 'BIO-C & Electrolytes PROF. (SMACLYT)',
      description:
        'Glucose AC, urea, total bilirubin, calcium, creatinine, cholesterol, uric acid, alkaline, phosphatase, AST, LDH, total protein, albumin, phosphorus, ALT, GGT, triglycerides, Na, K, Cl'
    },
    {
      type: 'boolean',
      id: 'SMA6',
      label: 'BIO6 PROFILE (SMA6)',
      description: 'Glucose AC, urea, creatinine, Na, K, Cl'
    },
    {
      type: 'boolean',
      id: 'SMA12',
      label: 'BIO12 PROFILE (SMA12)',
      description:
        'Albumin, glucose AC, urea, total bilirubin, calcium, creatinine, cholesterol, uric acid, alkaline phosphatase, AST, LDH, total protein'
    },
    {
      type: 'boolean',
      id: 'SMA12LYT',
      label: 'BIO-12 & Electrolytes Profile (SMA12LYT)',
      description:
        'Albumin, glucose AC, urea , total bilirubin, calcium, creatinine, cholesterol, uric acid, alkaline phosphatase , AST, LDH, total protein Na, K, Cl'
    },
    {
      type: 'boolean',
      id: 'FERT1',
      label: 'FERTILITY PROFILE #1 (FERT1)',
      description: 'FSH, LH'
    },
    {
      type: 'boolean',
      id: 'FERT2',
      label: 'FERTILITY PROFILE #2 (FERT2)',
      description: 'FSH, LH, Prolactin'
    },
    {
      type: 'boolean',
      id: 'LIPID',
      label: 'LIPID PROFILE fasting (LIPID)',
      description: 'Total cholesterol, triglycerides, HDL, LDL Non-HDL-C'
    },
    {
      type: 'boolean',
      id: 'NFLIPID',
      label: 'LIPID PROFILE non-fasting (NFLIPID)',
      description: 'Total cholesterol, triglycerides, HDL, LDL, NON HDL-C'
    },
    {
      type: 'boolean',
      id: 'LFT',
      label: 'LIVER FUNCTION PROFILE (LFT)',
      description: 'ALT, AST, alkaline phosphatase, bilirubin total, LDH, GGT'
    },
    {
      type: 'boolean',
      id: 'GP1',
      label: 'GENERAL PROFILE #1 (GP1)',
      description:
        'Glucose AC, urea, total bilirubin, calcium, creatinine, cholesterol, uric acid, alkaline phosphatase, AST, LDH, total protein, albumin, phosphorus, ALT, GGT, triglycerides, hemogram, urinalysis'
    }
  ],
  fields2: [
    {
      type: 'boolean',
      id: 'GP2',
      label: 'GENERAL PROFILE #2 (GP2)',
      description: `Glucose AC, urea, total bilirubin,
        creatinine, calcium, cholesterol, uric acid,
        alkaline phosphatase, AST, LDH, total
        protein, albumin, phosphorus, ALT, GGT,
        hemogram, triglycerides, urinalysis, Na,
        K, Cl`
    },
    {
      type: 'boolean',
      id: 'GP3',
      label: 'GENERAL PROFILE #3 (GP3)',
      description: 'General profile #1(GP1) & HDL-LDL'
    },
    {
      type: 'boolean',
      id: 'GP4',
      label: 'GENERAL PROFILE #4 (GP4)',
      description: 'General profile #2 (GP2) & HDL-LDL'
    },
    {
      type: 'boolean',
      id: 'HEPAB',
      label: 'HEPATITIS A & BScreen (HEPAB)',
      description: 'HBsAg, Anti-HBs, Anti-HBc, Anti-HAV IgM'
    },
    {
      type: 'boolean',
      id: 'HEPB',
      label: 'HEPATITIS BScreen (HEPB)',
      description: 'HBsAg, Anti-HBs, Anti-HBc'
    },
    {
      type: 'boolean',
      id: 'MONOP',
      label: 'MONOSCREEN PROFILE (MONOP)',
      description: 'Hemogram, Monotest'
    },
    {
      type: 'boolean',
      id: 'OSTEOP',
      label: 'OSTEOPOROSIS PROFILE (OSTEOP)',
      description: `Serum Alkaline phosphatase, calcium,
        creatinine, phosphorus, total protein,
        ionized calcium, protein electrophoresis,
        PTH
        Urine ≠ Calcium, creatinine,
        calcium/creatinine ratio, phosphorus`
    },
    {
      type: 'boolean',
      id: 'PREN1',
      label: 'PRENATAL PROFILE (PREN1)',
      description: 'Hemogram, blood group & Rh, maternal antibodies'
    },
    {
      type: 'boolean',
      id: 'FPSA',
      label: 'PROSTATE PROFILE (FPSA)',
      description: 'PSA Total & Free'
    },
    {
      type: 'boolean',
      id: 'STONE',
      label: 'RENAL STONE PROFILE (STONE)',
      description: `Serum: Calcium, alkaline phosphatase,
        Na, K, Cl, uric acid
        24hr Urine: Calcium, phosphate,
        creatinine, uric acid, oxalate, citrate,
        sodium, magnesium
        Random urine: urinalysis as indicated`
    },
    {
      type: 'boolean',
      id: 'TH2',
      label: 'THYROID #2 PROFILE (TH2)',
      description: 'Free T4, TSH'
    },
    {
      type: 'boolean',
      id: 'UC',
      label: 'URINE PROFILE (UC)',
      description: 'Urinalysis & culture'
    }
  ]
};

export const qcIndividualFields: { [key: string]: Array<LabReqTestOption> } = {
  fields1: [
    {
      type: 'boolean',
      id: 'FETO',
      label: 'AFP (alpha-fetoprotein) (FETO)'
    },
    {
      type: 'boolean',
      id: 'ALB',
      label: 'Albumin (ALB)'
    },
    {
      type: 'boolean',
      id: 'ALK',
      label: 'Alkaline phosphatase (ALK)'
    },
    {
      type: 'boolean',
      id: 'ALT',
      label: 'ALT (ALT)'
    },
    {
      type: 'boolean',
      id: 'AMYL',
      label: 'Amylase (AMYL)'
    },
    {
      type: 'boolean',
      id: 'ANA',
      label: 'ANA (ANA)'
    },
    {
      type: 'boolean',
      id: 'DNA',
      label: 'Anti-DNA (DNA)'
    },
    {
      type: 'boolean',
      id: 'ENA',
      label: 'Anti-ENA (ENA)'
    },
    {
      type: 'boolean',
      id: 'TAPRO',
      label: 'Anti-TPO & Anti-thyroglobulin (TAPRO)'
    },
    {
      type: 'boolean',
      id: 'APOA',
      label: 'Apolipoprotein A1 (APOA)'
    },
    {
      type: 'boolean',
      id: 'APOB',
      label: 'Apolipoprotein B (APOB)'
    },
    {
      type: 'boolean',
      id: 'ASTO',
      label: 'ASOT (ASTO)'
    },
    {
      type: 'boolean',
      id: 'AST',
      label: 'AST (AST)'
    },
    {
      type: 'boolean',
      id: 'BSQUAL',
      label: 'B-hCG (qualitative) (BSQUAL)'
    },
    {
      type: 'boolean',
      id: 'BSQUANT',
      label: 'B-hCG (quantitative) (BSQUANT)'
    },
    {
      type: 'boolean',
      id: 'BILID',
      label: 'Bilirubin direct (BILID)'
    },
    {
      type: 'boolean',
      id: 'BILIT',
      label: 'Bilirubin total (BILIT)'
    },
    {
      type: 'boolean',
      id: 'BLOOD',
      label: 'Blood Group & Rh (BLOOD)'
    },
    {
      type: 'boolean',
      id: 'CA125',
      label: 'CA125 (CA125)'
    },
    {
      type: 'boolean',
      id: 'CA',
      label: 'Calcium (CA)'
    },
    {
      type: 'boolean',
      id: 'CEA',
      label: 'CEA (CEA)'
    },
    {
      type: 'boolean',
      id: 'CHOL',
      label: 'Cholesterol total (CHOL)'
    },
    {
      type: 'boolean',
      id: 'CORTIAM',
      label: 'Cortisol: 8:00 a.m. (CORTIAM)'
    },
    {
      type: 'boolean',
      id: 'CORTIPM',
      label: 'Cortisol: 16:00 p.m. (CORTIPM)'
    },
    {
      type: 'boolean',
      id: 'CREA+GFR',
      label: 'Creatinine (CREA+GFR or CREA <18 yrs.)'
    },
    {
      type: 'boolean',
      id: 'CREACL',
      label: 'Creatinine Clearance 24h Urine (CREACL)'
    },
    {
      type: 'boolean',
      id: 'CK',
      label: 'Creatinine kinase (CK)'
    },
    {
      type: 'boolean',
      id: 'CRP',
      label: 'CRP (CRP)'
    },
    {
      type: 'boolean',
      id: 'CRPHS',
      label: 'CRP high sensitivity (CRPHS)'
    },
    {
      type: 'boolean',
      id: 'CSC',
      label: 'Culture cervix (CSC)'
    },
    {
      type: 'boolean',
      id: 'CST',
      label: 'Culture throat (CST)'
    },
    {
      type: 'boolean',
      id: 'CSV',
      label: 'Culture urethral (CSV)'
    },
    {
      type: 'boolean',
      id: 'CSU',
      label: 'Culture urine (CSU)'
    },
    {
      type: 'boolean',
      id: 'CVA',
      label: 'Culture vaginal (CVA)'
    },
    {
      type: 'boolean',
      id: 'CUL',
      label: 'Culture _______specify source (CUL)'
    },
    {
      type: 'boolean',
      id: 'DIG',
      label: 'Digoxin (DIG)'
    },
    {
      type: 'boolean',
      id: 'ECG',
      label: 'ECG (with cardiologist interpretation)'
    },
    {
      type: 'boolean',
      id: 'LYTES',
      label: 'Electrolytes (Na, K, Cl) (LYTES)'
    },
    {
      type: 'boolean',
      id: 'ESTRA',
      label: 'Estradiol (ESTRA)'
    },
    {
      type: 'boolean',
      id: 'FERI',
      label: 'Ferritin (FERI)'
    },
    {
      type: 'boolean',
      id: 'FIT',
      label: 'FIT (FIT)'
    },
    {
      type: 'boolean',
      id: 'FOL',
      label: 'Folate (FOL)'
    },
    {
      type: 'boolean',
      id: 'FRU',
      label: 'Fructosamine (FRU)'
    },
    {
      type: 'boolean',
      id: 'FSH',
      label: 'FSH (FSH)'
    },
    {
      type: 'boolean',
      id: 'GGT',
      label: 'GGT (GGT)'
    },
    {
      type: 'boolean',
      id: 'GLURAN',
      label: 'Glucose random (GLURAN)'
    },
    {
      type: 'boolean',
      id: 'AC',
      label: 'Glucose AC (AC)'
    },
    {
      type: 'boolean',
      id: 'PC50g',
      label: 'Glucose PC 1 h 50g (PC50g)'
    },
    {
      type: 'boolean',
      id: 'GLU75',
      label: 'Glucose PC 2 h 75g (GLU75)'
    },
    {
      type: 'boolean',
      id: 'PREG75',
      label: 'Glucose PC 2 h 75g Gestational (PREG75)'
    },
    {
      type: 'boolean',
      id: 'HPYL',
      label: 'Helicobacter pylori Serology (HPYL)'
    },
    {
      type: 'boolean',
      id: 'DIA13HELI',
      label: 'Helicobacter pylori Breath (DIA13HELI)'
    },
    {
      type: 'boolean',
      id: 'HBEL',
      label: 'Hemoglobin electrophoresis (HBEL)'
    },
    {
      type: 'boolean',
      id: 'CBC',
      label: 'Hemogram (CBC)'
    },
    {
      type: 'boolean',
      id: 'HBA1CP',
      label: 'Hemoglobin A1C (HBA1CP)'
    },
    {
      type: 'boolean',
      id: 'HEPAG',
      label: 'Hepatitis A: anti-HAV IgG (HEPAG)'
    },
    {
      type: 'boolean',
      id: 'HEPAM',
      label: 'Hepatitis A: anti-HAV IgM (HEPAM)'
    },
    {
      type: 'boolean',
      id: 'HBS',
      label: 'Hepatitis B: HBsAg (HBS)'
    },
    {
      type: 'boolean',
      id: 'ANHBS',
      label: 'Hepatitis B: Anti-HBs (ANHBS)'
    },
    {
      type: 'boolean',
      id: 'HEPBC',
      label: 'Hepatitis B: Anti-HBc (HEPBC)'
    },
    {
      type: 'boolean',
      id: 'HEPC',
      label: 'Hepatitis C: Anti-HCV (HEPC)'
    }
  ],
  fields2: [
    {
      type: 'boolean',
      id: 'HIV',
      label: 'HVI 1-2 (combo) (HIV)'
    },
    {
      type: 'boolean',
      id: 'HOLTER24',
      label: 'Holter 24hr (HOLTER24)'
    },
    {
      type: 'boolean',
      id: 'HOLTER48',
      label: 'Holter 48hr (HOLTER48)'
    },
    {
      type: 'boolean',
      id: 'HOLTER72',
      label: 'Holter 72hr (HOLTER72)'
    },
    {
      type: 'boolean',
      id: 'LHOMO',
      label: 'Homocysteine (LHOMO)'
    },
    {
      type: 'boolean',
      id: 'ELEPRO',
      label: 'Immunofixation (ELEPRO)'
    },
    {
      type: 'boolean',
      id: 'IMQUANT',
      label: 'Immunoglobulin quantitative (IMQUANT)'
    },
    {
      type: 'boolean',
      id: 'LD',
      label: 'LDH (LD)'
    },
    {
      type: 'boolean',
      id: 'LH',
      label: 'LH (LH)'
    },
    {
      type: 'boolean',
      id: 'LIP',
      label: 'Lipase (LIP)'
    },
    {
      type: 'boolean',
      id: 'LI',
      label: 'Lithium (LI)'
    },
    {
      type: 'boolean',
      id: 'MG',
      label: 'Magnesium (MG)'
    },
    {
      type: 'boolean',
      id: 'MIALBP',
      label: 'Micro albumin (MIALBP)'
    },
    {
      type: 'boolean',
      id: 'MONO',
      label: 'Monotest (MONO)'
    },
    {
      type: 'boolean',
      id: 'UM',
      label: 'Mycoplasma & Urea plasma (UM)'
    },
    {
      type: 'boolean',
      id: 'PARVOG',
      label: 'Parvovirus IgG (PARVOG)'
    },
    {
      type: 'boolean',
      id: 'PARVOM',
      label: 'Parvovirus IgM (PARVOM)'
    },
    {
      type: 'boolean',
      id: 'PCA3',
      label: 'PCA3 (PCA3)'
    },
    {
      type: 'boolean',
      id: 'PHOS',
      label: 'Phosphorus (PHOS)'
    },
    {
      type: 'boolean',
      id: 'BSQUAL',
      label: 'Pregnancy Test Serum / qualitative (BSQUAL)'
    },
    {
      type: 'boolean',
      id: 'PREG',
      label: 'Urine qualitative (PREG)'
    },
    {
      type: 'boolean',
      id: 'BSQUANT',
      label: 'B-hCG serum quantitative (BSQUANT)'
    },
    {
      type: 'boolean',
      id: 'PROG',
      label: 'Progesterone (PROG)'
    },
    {
      type: 'boolean',
      id: 'PROL',
      label: 'Prolactin (PROL)'
    },
    {
      type: 'boolean',
      id: 'PROT',
      label: 'Protein total (PROT)'
    },
    {
      type: 'boolean',
      id: 'PSA',
      label: 'PSA Total (PSA)'
    },
    {
      type: 'boolean',
      id: 'PT',
      label: 'PT & INR (PT)'
    },
    {
      type: 'boolean',
      id: 'PTH',
      label: ' PTH (PTH)'
    },
    {
      type: 'boolean',
      id: 'PTT',
      label: 'PTT (PTT)'
    },
    {
      type: 'boolean',
      id: 'RA',
      label: 'Rheumatoid Factor (RA)'
    },
    {
      type: 'boolean',
      id: 'RETICP',
      label: 'Reticulocyte Count (RETICP)'
    },
    {
      type: 'boolean',
      id: 'RUB',
      label: 'Rubella IgG (RUB)'
    },
    {
      type: 'boolean',
      id: 'RUBIGM',
      label: 'Rubella IgM (RUBIGM)'
    },
    {
      type: 'boolean',
      id: 'SED',
      label: 'Sedimentation Rate (SED)'
    },
    {
      type: 'boolean',
      id: 'SEPTIN9',
      label: ' Septin9 (SEPTIN9)'
    },
    {
      type: 'boolean',
      id: 'SPER',
      label: 'Spermogram (SPER) § (Main Lab.)'
    },
    {
      type: 'boolean',
      id: 'SPECO',
      label: 'Sperm Count (SPECO) ≠'
    },
    {
      type: 'boolean',
      id: 'CLOS',
      label: 'Stool: Clostridium difficile (CLOS)'
    },
    {
      type: 'boolean',
      id: 'Ova',
      label: 'Stool: Ova & parasites X _____ (OP1P, 2P, 3P) ≠'
    },
    {
      type: 'boolean',
      id: 'STREP',
      label: 'Strep Group A Screen (Rapid & Cult) (STREP)'
    },
    {
      type: 'boolean',
      id: 'SYPH',
      label: 'Syphilis (SYPH)'
    },
    {
      type: 'boolean',
      id: 'T3F',
      label: 'T3 Free (T3F)'
    },
    {
      type: 'boolean',
      id: 'T3',
      label: 'T3 Total (T3)'
    },
    {
      type: 'boolean',
      id: 'T4F',
      label: 'T4 Free (T4F)'
    },
    {
      type: 'boolean',
      id: 'CTX',
      label: 'Telopeptide-C (CTX)'
    },
    {
      type: 'boolean',
      id: 'TESBIO',
      label: 'Testosterone PRIOR 10:00 a.m.) / Bioavailable (TESBIO)'
    },
    {
      type: 'boolean',
      id: 'TESLI',
      label: 'Free (TESLI)'
    },
    {
      type: 'boolean',
      id: 'TEST',
      label: 'Total (TEST)'
    },
    {
      type: 'boolean',
      id: 'TOXO',
      label: 'Toxoplasmosis IgG (TOXO)'
    },
    {
      type: 'boolean',
      id: 'TOXOM',
      label: 'Toxoplasmosis IgM (TOXOM)'
    },
    {
      type: 'boolean',
      id: 'TRIG',
      label: 'Triglycerides (TRIG)'
    },
    {
      type: 'boolean',
      id: 'TSH',
      label: 'TSH (TSH)'
    },
    {
      type: 'boolean',
      id: 'TSHR4',
      label: 'TSH reflex (TSHR4)'
    },
    {
      type: 'boolean',
      id: 'UREA',
      label: 'Urea (UREA)'
    },
    {
      type: 'boolean',
      id: 'URIC',
      label: 'Uric acid (URIC)'
    },
    {
      type: 'boolean',
      id: 'URI',
      label: 'Urinalysis (URI)'
    },
    {
      type: 'boolean',
      id: 'Urine',
      label: 'Urine 24hr collection ≠'
    },
    {
      type: 'boolean',
      id: 'B12',
      label: 'Vitamin B12 (B12)'
    },
    {
      type: 'boolean',
      id: 'VITD',
      label: 'Vitamin D 25-OH (VITD)'
    }
  ],
  fieldsTestSpec: [
    {
      type: 'boolean',
      id: 'PCRCHSD',
      label: 'Chlamydia NAAT (PCRCHSD)'
    },
    {
      type: 'boolean',
      id: 'NGONOTAA',
      label: 'Gonorrhea NAAT (NGONOTAA)'
    },
    {
      type: 'boolean',
      id: 'TRICHTAA',
      label: 'Trichomonas NAAT (TRICHTAA)'
    },
    {
      type: 'boolean',
      id: 'NGPCRD',
      label: 'Chlamydia & Gono NAAT (NGPCRD)'
    },
    {
      type: 'boolean',
      id: 'TGCD',
      label: 'Chlamydia, Gono & Trichomonas NAAT (TGCD)'
    }
  ],
  fieldsSpecSource: [
    {
      type: 'boolean',
      id: 'Cervical',
      label: 'Cervical'
    },
    {
      type: 'boolean',
      id: 'Vaginal',
      label: 'Vaginal'
    },
    {
      type: 'boolean',
      id: 'Urethral',
      label: 'Urethral Aptima swab'
    },
    {
      type: 'boolean',
      id: 'Urine',
      label: 'Urine Sterile container'
    }
  ]
};
